var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSummary = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m16.249 2.44.001.08v5.52c0 .315 0 .623.021.883.023.286.079.623.252.962a2.5 2.5 0 0 0 1.092 1.092c.34.173.677.229.962.252.26.021.568.021.883.021h5.52l.08.001c.617.03 1.16.573 1.189 1.19l.001.059v9.052c0 1.006 0 1.836-.055 2.513-.058.702-.18 1.348-.49 1.955a5 5 0 0 1-2.185 2.185c-.607.31-1.253.432-1.955.49-.677.055-1.507.055-2.513.055h-7.984l.558-1.117c.178-.356.267-.532.336-.657l.005-.01.009-.004c.125-.07.3-.158.657-.336l1.544-.772a3.75 3.75 0 0 0 0-6.708l-1.544-.772a22.655 22.655 0 0 1-.657-.336l-.01-.005-.004-.009a22.655 22.655 0 0 1-.336-.657l-.772-1.544a3.75 3.75 0 0 0-6.708 0l-.396.792V8.448c0-1.006 0-1.836.055-2.513.058-.702.18-1.348.49-1.955A5 5 0 0 1 6.48 1.795c.607-.31 1.253-.432 1.955-.49.677-.055 1.507-.055 2.513-.055H15l.06.001c.616.03 1.16.572 1.189 1.19Z",
  fill: "url(#summary_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.336 8.658c-.15.092-.334.092-.701.092H19.75c-.35 0-.525 0-.659-.068a.625.625 0 0 1-.273-.273c-.068-.134-.068-.309-.068-.659V3.865c0-.367 0-.55.092-.7a.67.67 0 0 1 .68-.282c.17.041.29.161.53.4l4.165 4.166c.239.239.359.358.4.53a.67.67 0 0 1-.281.679Z",
  fill: "url(#summary_svg__b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.618 16.941a1.25 1.25 0 0 0-2.236 0l-.772 1.544c-.353.707-.461.91-.592 1.08-.13.17-.283.322-.453.453-.17.131-.373.239-1.08.592l-1.544.772a1.25 1.25 0 0 0 0 2.236l1.544.772c.707.353.91.461 1.08.592.17.13.322.283.453.454.131.17.239.372.592 1.079l.772 1.544a1.25 1.25 0 0 0 2.236 0l.772-1.544c.353-.707.461-.91.592-1.08.13-.17.283-.322.454-.453.17-.131.372-.239 1.079-.592l1.544-.772a1.25 1.25 0 0 0 0-2.236l-1.544-.772c-.707-.353-.91-.461-1.08-.592a2.505 2.505 0 0 1-.453-.454c-.131-.17-.239-.372-.592-1.079l-.772-1.544Zm-1.62 4.15c.187-.242.341-.503.502-.806.16.303.315.564.502.806.262.34.567.645.907.907.242.187.503.341.806.502-.303.16-.564.315-.806.502-.34.262-.645.567-.907.907a5.54 5.54 0 0 0-.502.806 5.539 5.539 0 0 0-.502-.806 5.002 5.002 0 0 0-.907-.907 5.531 5.531 0 0 0-.806-.502c.303-.16.564-.315.806-.502.34-.262.645-.567.907-.907Z",
  fill: "url(#summary_svg__c)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "summary_svg__a",
  x1: 1.25,
  y1: 15,
  x2: 26.25,
  y2: 15,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8BBDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BAD4FC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "summary_svg__b",
  x1: 1.25,
  y1: 15,
  x2: 26.25,
  y2: 15,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8BBDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BAD4FC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "summary_svg__c",
  x1: 1.25,
  y1: 15,
  x2: 26.25,
  y2: 15,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8BBDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BAD4FC"
})))));
export default SvgSummary;